import { useAtomValue, useSetAtom } from 'jotai';
import { sessionAtom, isAuthenticatedAtom, userAtom, tokenAtom } from '@/store/auth';

const AUTH_SERVICE_URL = import.meta.env.VITE_AUTH_SERVICE_URL || 'https://auth.advia.tech';

export function useAuth() {
  const session = useAtomValue(sessionAtom);
  const isAuthenticated = useAtomValue(isAuthenticatedAtom);
  const user = useAtomValue(userAtom);
  const token = useAtomValue(tokenAtom);

  return {
    session,
    isAuthenticated,
    user,
    token,
  };
}

export function useSetSession() {
  return useSetAtom(sessionAtom);
}

export function useLogout() {
  const setSession = useSetAtom(sessionAtom);

  return () => {
    setSession(null);
    window.location.href = '/';
  };
}

export function useLoginRedirect() {
  return () => {
    const currentUrl = window.location.href;
    const loginUrl = new URL(`${AUTH_SERVICE_URL}/`);
    loginUrl.searchParams.set('redirect_to', currentUrl);
    window.location.href = loginUrl.toString();
  };
}
